import { useIntl } from 'react-intl';
import { getTrailFeatureLabel } from '@alltrails/trails';
import type TrailFeature from '@alltrails/types/TrailFeature';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const features: TrailFeature[] = [
  'waterfall',
  'views',
  'wild-flowers',
  'lake',
  'river',
  'forest',
  'wildlife',
  'beach',
  'cave',
  'hot-springs',
  'historic-site',
  'rails-trails',
  'city-walk',
  'pub-crawl',
  'event'
];

export const getValidFeatures = (feats: string[]) => feats.filter(feat => features.includes(feat as TrailFeature)) as TrailFeature[];

const useFeatureFilterConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useCheckboxFilterConfig({
    exploreServiceFilterKey: 'feature',
    exploreServiceFilters,
    getValueLabel: feature => getTrailFeatureLabel(intl, feature),
    label: intl.formatMessage({ defaultMessage: 'Attractions' }),
    onFiltersChange,
    values: features
  });
};

export default useFeatureFilterConfig;
